App.BannersEditController = Em.Controller.extend
  session:  Em.inject.service()
  notifier: Em.inject.service()
  env:      Em.inject.service('environment')

  needs: [ 'banners', 'bannersIndex' ]

  organizationBinding: 'banner.organization'

  bannerBinding: 'model'

  isLoading: false

  hasMobileConfig:   Em.computed.alias('env.features.hasMobileConfig')

  restaurantsSortOrder: ['city','name']
  restaurants: Ember.computed.sort('controllers.banners.restaurants', 'restaurantsSortOrder')

  contentType: (->
    if @get('banner.has_clickable_popup') || @get('banner.has_popup_on_start')
      return 'usePopup'
    else
      return 'useLink'
  ).property('banner.has_clickable_popup', 'banner.has_popup_on_start')

  isLinkType: Em.computed.equal('contentType', 'useLink')
  isPopupType: Em.computed.equal('contentType', 'usePopup')

  disableLinkTab: (->
    @get('isPopupType') && (@get('banner.has_clickable_popup') || @get('banner.has_popup_on_start'))
  ).property('isPopupType', 'banner.has_clickable_popup', 'banner.has_popup_on_start')

  selectedKinds: (->
    currentKinds = @get('banner.kind') || []
    currentKinds.map (kind) ->
      {id: kind, name: Em.I18n.t "banners.main.kind.#{kind}"}
  ).property('banner.kind')

  availableKindsNames: ( ->
    [
      {id: 'web', name: Em.I18n.t 'banners.main.kind.web'},
      {id: 'mobile', name: Em.I18n.t 'banners.main.kind.mobile'}
    ]
  ).property('availableKindsNames')

  selectedRestaurans: Em.computed.gt('banner.restaurants.length', 0)

  selectedRestaurantNames: ( ->
    r = @get('banner.restaurants').map((e) -> e.get('name')).join(', ')

    return Em.I18n.t 'banner.filter.restaurants.zero_data' if r == ''
    Em.I18n.t 'banner.filter.restaurants.content', restaurants: r
  ).property('banner.restaurants')

  saveBanner: ->
    if @get('disableLinkTab')
      @set('banner.url_web', '')
      @set('banner.url_mobile', '')
    @get('banner').save()

  actions:
    wouldUploadPhoto: (permission) ->
      banner = @get('banner')
      return permission.resolve() unless banner.get('isNew')

      # todo i18n
      if confirm Em.I18n.t 'banner.confirm.save'
        @saveBanner().then =>
          permission.resolve()
        , =>
          permission.reject()
      else
        permission.reject()
      false

    cancel: ->
      banner = @get('banner')

      if banner.get('isDirty') or banner.get('isNew')
        return unless confirm Em.I18n.t 'banner.confirm.cancel'
        banner = @get('banner')
        banner.rollback()

      @send('goBackToBannerList')
      false

    deleteBanner: ->
      return unless confirm Em.I18n.t 'banner.confirm.delete'

      banner = @get('banner')
      banner.destroyRecord()
      .then =>
        @transitionToRoute('banners')

      false

    saveBanner: ->
      @set('isLoading', true)
      banner = @get('banner')
      wasNew = banner.get('isNew')

      statusText = Em.I18n.t "banner.notifier.status.#{if wasNew then 'new' else 'old'}"

      kinds = @get('selectedKinds').map (kind) -> kind.id
      banner.set('kind', kinds)
      @saveBanner()
      .then =>
        @set('isLoading', false)
        @transitionToRoute('banners')
        banner.reload()
        @get('notifier').pushNotification
          type:     'success'
          title:    Em.I18n.t 'banner.notifier.title', text: statusText
          duration: 3000

      false
